import { getBackendUrl } from "../config";

const R2_PUBLIC_BASE = "https://pub-1ee49b423fb0441183f8f72f39897cc7.r2.dev";

function apiUrl(path) {
  const backendUrl = getBackendUrl();
  if (!backendUrl) return "";
  return `${backendUrl}${path}`;
}

function s3FileUrl(item) {
  const storageKey = String(item?.storageKey || "").replace(/^\/+/, "");
  const existing = String(item?.publicUrl || "");
  if (storageKey) {
    return `${R2_PUBLIC_BASE}/${storageKey}`;
  }
  if (existing && !existing.includes("/api/media/file/")) {
    return existing;
  }
  return existing;
}

const CATALOG_EXTRAS = [
  {
    key: "video-eran",
    type: "video",
    group: "graduate-videos",
    storageKey: "greatleaders-academy/videos/eran.mp4",
    alt: "ערן",
    sortOrder: 24,
    meta: {
      name: "ערן",
      role: "בוגר קורס פיתוח מנהיגות",
    },
  },
];

function mergeCatalogExtras(items, byKey) {
  for (const extra of CATALOG_EXTRAS) {
    if (byKey[extra.key]) continue;
    const item = { ...extra, publicUrl: s3FileUrl(extra) };
    items.push(item);
    byKey[extra.key] = item;
  }
  return { items, byKey };
}

export async function fetchSiteMedia() {
  const url = apiUrl("/api/media");
  if (!url) {
    return mergeCatalogExtras([], {});
  }

  const response = await fetch(url, { cache: "no-store" });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.success === false) {
    throw new Error(data.error || "טעינת המדיה נכשלה");
  }

  const items = (Array.isArray(data.items) ? data.items : []).map((item) => ({
    ...item,
    publicUrl: s3FileUrl(item),
  }));
  const byKey = {};
  for (const item of items) {
    byKey[item.key] = item;
  }

  return mergeCatalogExtras(items, byKey);
}
